import React from 'react';

import { IActiveCampaignFragment } from 'generated/sanity-graphql';

import { CampaignIds } from '../constants';
import { PhysicalCardCampaignFields } from '../extra-fields';

interface IAuthCampaignParams {
  campaignId?: string | null;
  campaignContent?: IActiveCampaignFragment | null;
}

export interface IAuthCampaign {
  extraFields?: JSX.Element;
}

const useAuthCampaign = ({ campaignId, campaignContent }: IAuthCampaignParams): IAuthCampaign => {
  let extraFields;

  if (!campaignContent) {
    return { extraFields };
  }

  switch (campaignId) {
    case CampaignIds.PHYSICAL_CARD:
      extraFields = <PhysicalCardCampaignFields />;
      break;

    default:
      break;
  }

  return {
    extraFields: campaignContent.shouldDisplayExtraFields ? extraFields : undefined,
  };
};

export default useAuthCampaign;
